import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './executiveDashboard.jade';

export class ExecutiveDashboardController {
  /* @ngInject */
  constructor($filter, $window, currentUser, hideThatProduct) {
    this.translate = $filter('translate');
    this.$window = $window;
    this.hideThatProduct = hideThatProduct;
    this.atAGlanceTitle = 'simplaexCampaignsAtAGlance'
    currentUser.subscribe((user) => {
      if(user) {
        this.showEngagementTab = !user.hasRole(['SELLER_ONLY', 'BUYER_ONLY']);
        this.showAcquisitionTab = !user.hasRole('SELLER_ONLY');
        this.showSellingTab = !user.hasRole(['BUYER_ONLY']);

        if (this.$window.location.href && this.$window.location.href.includes("mdsp.affle.com")){
          this.atAGlanceTitle = 'affleCampaignsAtAGlance'
        }
        this.hideAcquisitionProduct = this.hideThatProduct.hideAcquisitionProduct(user);
      }
    });

    this.currency = 'USD';

    this.showAnalytics = true;

    this.breakdownSeries = {
      engagement: [
        {
          metric: 'impressions',
          format: 'number'
        },
        {
          metric: 'ctr',
          format: 'percentage'
        },
        {
          metric: 'clicks',
          format: 'number'
        },
        {
          metric: 'engaged_players',
          format: 'number'
        },
        {
          metric: 'conversion_rate',
          format: 'percentage'
        },
        {
          metric: 'cost',
          format: (() => this.currency)
        },
        {
          metric: 'ecpe',
          format: (() => this.currency)
        }
      ],
      acquisition: [
        {
          metric: 'impressions',
          format: 'number'
        },
        {
          metric: 'ctr',
          format: 'percentage'
        },
        {
          metric: 'clicks',
          format: 'number'
        },
        {
          metric: 'leads',
          format: 'number'
        },
        {
          metric: 'conversion_rate',
          metricForTranslation: 'cr',
          format: 'percentage'
        },
        {
          metric: 'cpqi',
          format: (() => this.currency)
        },
        {
          metric: 'ecpqi',
          format: (() => this.currency)
        }
      ],
      selling: [
        //{
        //  metric: 'impressions',
        //  format: 'number'
        //},
        {
          metric: 'clicks',
          format: 'number'
        },
        {
          metric: 'leads',
          format: 'number'
        },
        {
          metric: 'conversion_rate',
          metricForTranslation: 'cr',
          format: 'percentage'
        },
        {
          metric: 'seller_share',
          format: (() => this.currency)
        },
        {
          metric: 'erpi',
          format: (() => this.currency)
        }
      ]
    };

    this.tableCols = {
      engagement: [
        {
          field: 'game_name',
          sortable: 'game_name',
          title: this.translate('app'),
          show: true
        },
        {
          field: 'campaign_name',
          sortable: 'campaign_name',
          title: this.translate('campaign'),
          show: true
        }
      ],
      acquisition: [
        {
          field: 'game_name',
          sortable: 'game_name',
          title: this.translate('app'),
          show: true
        },
        {
          field: 'campaign_name',
          sortable: 'campaign_name',
          title: this.translate('campaign'),
          show: true
        }
      ],
      selling: [
        {
          field: 'game_name',
          sortable: 'game_name',
          title: this.translate('app'),
          show: true
        },
        {
          field: 'segment_name',
          sortable: 'segment_name',
          title: this.translate('segment'),
          show: true
        }
      ]
    };
  }
}

export function ExecutiveDashboardComponent() {
  return {
    template,
    controller: ExecutiveDashboardController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      query: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.games.executiveDashboard', [
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('executiveDashboard', ExecutiveDashboardComponent);



/** WEBPACK FOOTER **
 ** ./src/components/games/executiveDashboard.js
 **/